define('_views/Messages',[
	'../../admin/_models/imageupload.js',
	'text!_templates/messages.html',
	'_views/Message-Single',
	'_collections/Messages',
	'_models/Message',
],
function(
	ImageUploadModel,
	MessageListTemplate,
	MessageView,
	MessagesCollection,
	MessageModel
) {

	var splitUri = function(uri) {
		var splitted = uri.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
		return splitted;
	};

	function is_iri(value) {
		if (!value) {
			return false;
		}

		// check for illegal characters
		if (/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(value)) return false;

		// check for hex escapes that aren't complete
		if (/%[^0-9a-f]/i.test(value)) return false;
		if (/%[0-9a-f](:?[^0-9a-f]|$)/i.test(value)) return false;

		var splitted = [];
		var scheme = '';
		var authority = '';
		var path = '';
		var query = '';
		var fragment = '';
		var out = '';

		// from RFC 3986
		splitted = splitUri(value);
		scheme = splitted[1]; 
		authority = splitted[2];
		path = splitted[3];
		query = splitted[4];
		fragment = splitted[5];

		if(authority.split('.').length < 2 || authority.split('.')[1].length <= 1) {
			return false;
		}

		// scheme and path are required, though the path can be empty
		if (!(scheme && scheme.length && path.length >= 0)) return false;

		// if authority is present, the path must be empty or begin with a /
		if (authority && authority.length) {
			if (!(path.length === 0 || /^\//.test(path))) return false;
		} else {
			// if authority is not present, the path must not start with //
			if (/^\/\//.test(path)) return false;
		}

		// scheme must begin with a letter, then consist of letters, digits, +, ., or -
		if (!/^[a-z][a-z0-9\+\-\.]*$/.test(scheme.toLowerCase()))  return false;

		// re-assemble the URL per section 5.3 in RFC 3986
		out += scheme + ':';
		if (authority && authority.length) {
			out += '//' + authority;
		}

		out += path;

		if (query && query.length) {
			out += '?' + query;
		}

		if (fragment && fragment.length) {
			out += '#' + fragment;
		}

		return true;
	}

	function is_http_iri(value, allowHttps) {
		if (!is_iri(value)) {
			return false;
		}

		var splitted = [];
		var scheme = '';
		var authority = '';
		var path = '';
		var port = '';
		var query = '';
		var fragment = '';
		var out = '';

		// from RFC 3986
		splitted = splitUri(value);
		scheme = splitted[1]; 
		authority = splitted[2];
		path = splitted[3];
		query = splitted[4];
		fragment = splitted[5];

		if (!scheme)  return false;

		if(allowHttps) {
			if (scheme.toLowerCase() != 'https') return false;
		} else {
			if (scheme.toLowerCase() != 'http') return false;
		}

		// fully-qualified URIs must have an authority section that is
		// a valid host
		if (!authority) {
			return false;
		}

		// enable port component
		if (/:(\d+)$/.test(authority)) {
			port = authority.match(/:(\d+)$/)[0];
			authority = authority.replace(/:\d+$/, '');
		}

		out += scheme + ':';
		out += '//' + authority;
		
		if (port) {
			out += port;
		}
		
		out += path;
		
		if(query && query.length){
			out += '?' + query;
		}

		if(fragment && fragment.length){
			out += '#' + fragment;
		}
		
		return true;
	}

	function is_https_iri(value) {
		return is_http_iri(value, true);
	}

	function is_web_iri(value) {
		return (is_http_iri(value) || is_https_iri(value));
	}

	function returnSchemedURL(url) {

		if(url === "") {
			return "";
		}

		var parts = splitUri(url),
			scheme = parts[1];

		if (!scheme || (scheme.toLowerCase() != 'https' && scheme.toLowerCase() != 'http')) {
			url = "http://" + url;
		}

		return url;

	}

	return Backbone.View.extend({

		template: _.template(MessageListTemplate),

		messsagesPerPage: 10,

		pagesLoaded: 1, // we load one page from the DOM

		paginating: false,

		paginationLimitReached: false,

		events : {
			'click [data-toggle-new-message]': 'toggleNewMessage',
			'click .delete-top-right': 'toggleNewMessage',
			'click [data-contact]'	: 'openContactPanel',
			'click #send-new-message': 'sendNewMessage',
			'drop .image-bucket' : 'handleImageFile',
			'dragenter .image-bucket' : 'showDropOver',
			'change [data-file-upload-input]': 'handleImageFile',
			'click .image-bucket' : 'openFileDialog',
			'mousedown .clickable' : 'preventDefault',
		},

		preventDefault: function(e){
			e.preventDefault();
		},

		initialize: function(){
			
			this.collection = new MessagesCollection();

			this.collection.on('add', this.renderSingleMessage, this);

			this.collection.on('add', this.checkUpdateHeader, this);
			this.collection.on('remove', this.checkUpdateHeader, this);

			// infinite scrolling listener
			var _this = this,
				distanceToBottom = 0;

			$('.container.backstage').on('scroll.backstage-message-pagination', _.throttle(function(e){

				if(_this.paginationLimitReached) {
					$('.container.backstage').off('scroll.backstage-message-pagination');
				}

				// check if we're hidden or not
				if( ! _this.$el.parent().hasClass('hidden') ) {

					distanceToBottom = Math.max(e.currentTarget.scrollHeight - (e.currentTarget.scrollTop + e.currentTarget.offsetHeight), 0);

					if(distanceToBottom < 400) {
						_this.autoPaginate();
					}

				}

			}, 100));

		},

		render: function(e) {

			this.$el.html(
				this.template({
					defaults : this.model.toJSON()
				})
			);

			// Fetch the collection on render
			this.collection.fetch({ reset: true });

			// Cache
			this.$els = {
				newMessage: this.$el.find('[data-new-message]'),
				toggleMessage: this.$el.find('[data-show-new-message]'),
				resetMessage: this.$el.find('[data-hide-new-message]'),
				imagePreviewElement: this.$el.find('[data-update-image-preview]')[0],
				bucketNoteElement: this.$el.find('.image-bucket-note')[0],
				updatesHeader: this.$el.find('[data-updates-header]'),
				imageUploadProgressContainer: this.$el.find('[data-image-upload-progress-container]')
			}

			this.checkUpdateHeader();

			_this = this;
			$('#drag_overlay', this.el).on('dragleave', function(e){
				_this.hideDropOver(e);
			}).on('dragover', function(e){
				_this.preventDefault(e);
			}).on('drop', function(e){
				_this.handleImageFile(e);
			});

			setTimeout((function(){
 				$('textarea', this.el).textareaAutoSize();
			}).bind(this), 250);

			return this;

		},

		/**
		 * To offload some of the load time, 
		 * only show the images when the backstage panel is open
		 */
		checkAndShowMessageImage: function(force) {
			if(force === true || Backstage.View.Main.data.parent.Cargo.View.Backstage.enabled === true) {
				$("[data-message-list] [data-image]", this.el).each(function() {
					if($(this).data('img')) {
						$(this).attr('src', $(this).data('img'));
						$(this).removeAttr('data-img');
					}
				});
			}
		},

		showDropOver: function(e) {
			this.preventDefault(e);
			this.$el.find('#drag_overlay').css('top', $('#slide-container').scrollTop()).show();
			$('#slide-container').addClass('noscroll');
		},

		hideDropOver: function(e) {
			this.$el.find('#drag_overlay').hide();
			$('#slide-container').removeClass('noscroll');
		},

		autoPaginate: function(){

			if(this.paginating || this.paginationLimitReached) {
				return;
			}

			var jqXHR = this.collection.fetch({
				data: {
					offset: this.collection.length, 
					limit: this.messsagesPerPage
				}, 
				remove: false
			});

			if(jqXHR !== undefined) {

				this.paginating = true;

				jqXHR.always(_.bind(function(models){

					if(models.length < this.messsagesPerPage) {
						this.paginationLimitReached = true;
					}

					this.paginating = false;

				}, this));

			} 

		},

		checkUpdateHeader: function(){

			if(this.$els === undefined || this.model.get('is_owner')) {
				return false;
			}

			if(this.collection.length === 0) {
				this.$els.updatesHeader.css('display', 'none');
			} else {
				this.$els.updatesHeader.css('display', '');
			}

		},

		imagePreviewFile: undefined,

		openFileDialog: function(e){

			if(e.target.nodeName === "INPUT") {
				return;
			}

			e.preventDefault();

			$('[data-file-upload-input]').click();
		},

		validators: {
			'not-empty-if-no-image': function(element){

				if(this.imagePreviewFile === undefined) {
					return element.value.length > 0;
				}
				
				return true;

			},
			'valid-url': function(element){

				if(element.value === "") {
					return true;
				}

				return is_web_iri(returnSchemedURL(element.value));
			}
		},

		validateInput: function(element){

			var isValid = true,
				_this = this,
				validators = element.getAttribute('data-validate');

			if(validators == null) {
				return false;
			}

			_.each(validators.toLowerCase().split(' '), function(validator){

				if(this.validators[validator].call(_this, element) === false) {
					isValid = false;
				}

				if(validator === "not-empty-if-no-image") {
					_this.once('image-preview-file-update', function(){
						_this.validateInput(element);
					});
				}

			}, this);

			if(isValid === false) {
				$(element).one('input.inputValidation', function(){
					_this.validateInput(element);
				});

				$(element).addClass('invalid');
			} else if($(element).hasClass('invalid')) {
				$(element).removeClass('invalid');
			}

			return isValid;

		},

		validateForm: function(){

			var allValid = true,
				inputs = [],
				_this = this;

			this.$el.find('[data-validate]').each(function(index, el){

				var isValid = _this.validateInput(el);

				if(isValid === false) {
					allValid = false;
				}

				inputs.push({
					el: el,
					valid: isValid
				});

			});	

			return {
				valid: allValid,
				inputs: inputs
			};

		},

		handleImageFile: function(e, is_valid_file){

			e.preventDefault();

			this.hideDropOver();

			var fileArray;

			if(e.originalEvent.dataTransfer !== undefined){
				// drag 'n drop
				fileArray = e.originalEvent.dataTransfer.files;

			} else {
				// file input
				fileArray = e.currentTarget.files;
			}

			if(fileArray === undefined || fileArray.length === 0){
				return;
			}

			// test for file types, return if accepted
			if(!is_valid_file) {
				// will run this function again if files match
				this.TestFileType(fileArray[0].name.toLowerCase(), e);
				return;
			}

			this.imagePreviewFile = fileArray[0];

			if(this.$els.imagePreviewElement !== undefined) {

				this.trigger('image-preview-file-update');

				this.$els.imagePreviewElement.style.display = 'block';
				this.$els.imagePreviewElement.src = window.URL.createObjectURL(this.imagePreviewFile);

				this.$els.bucketNoteElement.style.display = 'none';
			}

		},

		// throw alert when file type does not match
		TestFileType: function(fileNames, e) {
			if (fileNames.match(/\.(jpg|jpeg|png|gif)$/i) === null) {

				parent.window.Cargo.Modal.Alert({
					message: 'Invalid file type<br><em>Accepted file types:<br>gif, jpg, jpeg, png or svg</em>',
					selector: 'html'
				});

			} else {
				this.handleImageFile(e, true)
			}
		},

		resetImageBucket: function() {
			this.imagePreviewFile = undefined;
			this.$els.imagePreviewElement.style.display = 'none';
			this.$els.bucketNoteElement.style.display = '';
			this.$els.imageUploadProgressContainer.removeClass('uploading pending');
			$('#new-message').val('');
		},

		renderSingleMessage: function(model){

			var message = new MessageView({
				model: model,
				defaults_model: this.model 
			});

			if(model.get('newly_created') === true) {
				this.$el.find('[data-message-list]').prepend( message.render().el );
			} else {
				this.$el.find('[data-message-list]').append( message.render().el );
			}

			return this;

		},

		closeNewMessage: function () {
			this.$els.newMessage
				.addClass('hidden-xs')
				.removeAttr('data-active');
			this.$els.toggleMessage
				.removeClass('hidden-xs');
			this.$els.resetMessage
				.addClass('hidden-xs');
			this.$els.newMessage
				.find('[data-update-image-preview]')
				.hide()
				.attr('src', '');
			this.$els.newMessage
				.find('.image-bucket-note')
				.css('display', '')
			this.$els.newMessage
				.find('input, textarea')
				.val('')
				.removeClass('invalid')
				.off('input.inputValidation');

			this.resetImageBucket();
		},

		openNewMessage: function () {
			this.$els.newMessage
				.removeClass('hidden-xs')
				.attr('data-active', '');
			this.$els.toggleMessage
				.addClass('hidden-xs');
			this.$els.resetMessage
				.removeClass('hidden-xs');
		},

		toggleNewMessage: function (e) {
			if (this.$els.newMessage.is('[data-active]')) {
				this.closeNewMessage();
			} else {
				this.openNewMessage();	
			}
		},

		sendNewMessage: function(e) {

			if(this.validateForm().valid === false) {
				return;
			}

			// this will close the keyboard if on mobile
			document.activeElement.blur();

			var t = new MessageModel({ 
				message 			: $('#new-message').val(), 
				link 				: returnSchemedURL($('#link').val()), 
				creator_site_url 	: this.model.get('site_url'),
				creator_site_name 	: this.model.get('site_name'),
				creator_site_id 	: this.model.get('site_id'),
				newly_created		: true
			});

			var _this = this;

			t.save(undefined, {
				success: function(model, response){

					if(response.id !== undefined && _this.imagePreviewFile !== undefined) {
						_this.uploadImageFileToServer(response.id, _this.imagePreviewFile, function(){

							_this.toggleNewMessage();
							_this.imagePreviewFile = undefined;

						});
					} else {

						_this.collection.add(t, {
							at: 0
						});

						_this.toggleNewMessage();

					}
					
				}
			});

		},

		openContactPanel: function() {
			Backstage.View.Main.data.parent.Cargo.Event.trigger("add_history", "backstage/contact");
		},

		uploadImageFileToServer: function(messageID, file, callback) {

			var _this = this;

			this.$els.imageUploadProgressContainer.removeClass('pending');
			this.$els.imageUploadProgressContainer.addClass('uploading');

			var img = new ImageUploadModel({
				'message_id': messageID,
				'type': 'backstage_post'
			});

			img.on('upload-complete', function(upload_model, image_model){

				_this.$els.imageUploadProgressContainer.removeClass('uploading');

				if(typeof callback === "function") {
					callback();
				}

			}, this);

			img.on('upload-success', function(model, jqXHR){

				//console.log('AYE', model);

				/*model.newly_created = true;
				_this.collection.add(model, {
					at: 0
				});*/

			}, this);

			img.on('upload-progress', function(model, e){

				if(e.lengthComputable){

					// multiply this by 0.9 because the last 10 percent are used to indicate processing
					var percentComplete = ((e.loaded / e.total) * 100);

					// Grab the percentage
					var $path  = _this.$els.imageUploadProgressContainer.find('path'),
						length = $path[0].getTotalLength(),
						degree_percentComplete = Math.round((length / 100) * percentComplete);

					// Set up the starting positions
					$path.css('strokeDasharray', length + ' ' + length);
					$path.css('strokeDashoffset', 'length');

					// Trigger a layout so styles are calculated & the browser
					// picks up the starting position before animating
					$path[0].getBoundingClientRect();
					$path.css('strokeDashoffset', length - degree_percentComplete);

					// Finished
					if( percentComplete >= 99 ) {

						// Complete the path
						$path
							.css({
								'strokeDasharray'  : '2 0',
								'strokeDashoffset' : 0,
							});

						// Complete the path
						setTimeout(function() {

							_this.$els.imageUploadProgressContainer.addClass('pending');

							$path.css({
								'strokeDasharray'  : '3 4.50'
							});

						// Give the CSS animation time to finish
						}, 200);

					}

				}

			}, this);

			img.uploadFile(file);

			/*var xhr = new Cargo.utils.CargoXHR({
				url: '/_api/v0/message/image/' + messageID,
				type: 'POST',
				data: formData,
				progress: function(e){
					
					


				},
				success: function(e){
					
					if (this.xhr.status == 200) {

						var response = JSON.parse(this.xhr.responseText);

						// finish load anim
						//setTimeout(function(){
							response.newly_created = true;
							_this.collection.add(response, {
								at: 0
							});
						//}, 200);
						


					} else {
						// fail
					}

				},
				always: function(){

					_this.$els.imageUploadProgressContainer.removeClass('uploading');

					if(typeof callback === "function") {
						// finish load anim
						//setTimeout(function(){
							callback();
						//}, 200);
					}
				}
			});*/

		}
	});

});



